import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./EditarTurma.module.css"
import Alerta from "../../components/alerta/Alerta";
import { Form, Button, Modal } from "react-bootstrap";
import TurmaApi from "../../services/TurmaApi";
import PessoaTurmaApi from "../../services/PessoaTurmaApi";
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { TiDelete } from "react-icons/ti";
import { MdSave } from "react-icons/md";
import Loader from '../../components/loader/Loader';
import InputBuscar from '../../components/inputBuscar/InputBuscar';
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function EditarTurma() {

    const location = useLocation();
    const navigate = useNavigate();

    //Recebe o Id da turma a ser editada
    const [turmaId] = useState(location.state);

    //Armazena os dados da turma
    const [turma, setTurma] = useState([])

  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");

    //Modais para desassociar pessoa de turma
    const [mostrarModalDeletar, setMostrarModalDeletar] = useState(false);
    const [mostrarModalAdicionarAluno, setMostrarModalAdicionarAluno] = useState(false);
    const [mostrarModalAdicionarMonitor, setMostrarModalAdicionarMonitor] = useState(false);

    //Para edicao dos dados de turma
    const [nomeNovo, setNomeNovo] = useState("");
    const [descricaoNovo, setDescricaoNovo] = useState("");
    const [periodoNovo, setPeriodoNovo] = useState("");
    const [modalidadeNovo, setModalidadeNovo] = useState("");
    const [statusNovo, setStatusNovo] = useState("");

    //Enuns de turma
    const [statusTurmas, setStatusTurmas] = useState([]);
    const [peridoTurmas, setPeriodoTurmas] = useState([]);
    const [modalidadeTurmas, setModalidadeTurmas] = useState([]);

    //Para edição de pessoas associadas a turmas
    const [pessoasDaTurma, setPessoasDaTurma] = useState([]);
    const [pessoaSelecionada, setPessoaSelecionada] = useState(null);
    const [pessoasAdicionar, setPessoasAdicionar] = useState([]);
    const [pessoasSemTurma, setPessoasSemTurma] = useState([]);
    const [monitoresSemTurmaEspecifica, setMonitoresSemTurmaEspecifica] = useState([]);

    const [loading, setLoading] = useState(false);

    //Função para abrir o modal de deletar
    const AbrirModalDeletar = (pessoa) => {
        setPessoaSelecionada(pessoa);
        setMostrarModalDeletar(true);
    };

    const AbrirModalAdicionarAluno = () => {
        setMostrarModalAdicionarAluno(true);
    };

    const AbrirModalAdicionarMonitor = () => {
        setMostrarModalAdicionarMonitor(true);
    };

    //Função para o fechar modal
    const FecharModal = () => {
        setMostrarModalDeletar(false);
        setMostrarModalAdicionarAluno(false);
        setMostrarModalAdicionarMonitor(false);
        setPessoaSelecionada(null);
        setPessoasAdicionar([]);
    };

    //Função para editar turma
    const BotaoEditarTurma = async () => {
        try {
            setLoading(true);
            await TurmaApi.editarTurmaComMoodleAsync(turmaId, nomeNovo, descricaoNovo, periodoNovo, modalidadeNovo, statusNovo);
            setMensagemAlerta(`Turma atualizada com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao atualizar turma: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        }
        finally {
            setLoading(false);
        }
    };

    //Função para remover pessoa da turma
    const BotaoRemoverPessoa = async () => {
        try {
            setLoading(true);
            await PessoaTurmaApi.deletarPessoaTurmaAsync(pessoaSelecionada.id);
            ObterPessoasDaTurma();
            ListarPessoasSemTurmas();
            ListarMonitoresSemTurmaEspecifica();
            FecharModal();
            setMensagemAlerta(`Desassociação realizada com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao desassociar pessoa: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            setLoading(false);
        }
    };

    //Função para adicionar pessoas a turma
    const BotaoAdicionarPessoa = async () => {
        try {
            setLoading(true);
            await PessoaTurmaApi.adicionarPessoasTurmaAsync(turmaId, pessoasAdicionar);
            ObterPessoasDaTurma();
            ListarPessoasSemTurmas();
            ListarMonitoresSemTurmaEspecifica();
            FecharModal();
            setMensagemAlerta(`Associação realizada com sucesso!`);
            setTipoAlerta("success");
            exibirAlerta(true);
        } catch (error) {
            setMensagemAlerta(`Erro ao adicionar pessoas à turma: ${error.response.data}`);
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            setLoading(false);
        }
    };

    //Função para exibir o alerta
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 10000);
    };

    //Obter os dados da turma
    const BuscarDadosDaTurma = async () => {
        try {
            const dadosTurma = await TurmaApi.obterDadosDaTurmaAsync(turmaId);
            setTurma(dadosTurma);
            setNomeNovo(dadosTurma.nome);
            setDescricaoNovo(dadosTurma.descricao);
            setPeriodoNovo(dadosTurma.periodo);
            setModalidadeNovo(dadosTurma.modalidade);
            setStatusNovo(dadosTurma.status);
        } catch (error) {
            console.error("Erro ao buscar dados da turma:", error.response.data);
        }
    };

    //Obter todos os status de turma
    const BuscarStatusTurma = async () => {
        try {
            const status = await TurmaApi.listarStatusTurmasAsync();
            setStatusTurmas(status);
        } catch (error) {
            console.error("Erro ao buscar status da turma:", error.response.data);
        }
    };

    //Função para obter todas as modalidade de turma
    const BuscarModalidadeTurma = async () => {
        try {
            const modalidade = await TurmaApi.listarModalidadeTurmasAsync();

            const modalidadesFormatadas = modalidade.map(m =>
                m.id === 2 ? { ...m, nome: "Híbrido" } : m
            );
            setModalidadeTurmas(modalidadesFormatadas);
        } catch (error) {
            console.error("Erro ao buscar modalidade da turma:", error.response.data);
        }
    };

    //Função para obter todos os periodos de turma
    const BuscarPeriodosTurma = async () => {
        try {
            const periodos = await TurmaApi.listarPeriodoTurmasAsync();

            const periodosFormatados = periodos.map(p =>
                p.id === 1 ? { ...p, nome: "Manhã" } : p
            );
            setPeriodoTurmas(periodosFormatados);
        } catch (error) {
            console.error("Erro ao buscar periodo da turma:", error.response.data);
        }
    };

    //Função para obter todas as pessoas associadas a turmas
    const ObterPessoasDaTurma = async () => {
        try {
            const listaPessoas = await TurmaApi.obterPessoasDaTurmaAsync(turmaId);
            setPessoasDaTurma(listaPessoas);
        } catch (error) {
            console.error("Erro ao buscar pessoas da turma:", error.response.data);
        }
    };

    //Função para listar pessoas sem turma
    const ListarPessoasSemTurmas = async () => {
        try {
            const listaPessoasSemTurma = await PessoaTurmaApi.listarPessoasSemTurmaAsync();
            setPessoasSemTurma(listaPessoasSemTurma);
        } catch (error) {
            console.error("Erro ao buscar pessoas: ", error.response.data);
        };
    };

    //Função para listar moniotres que não estão na respectiva turma
    const ListarMonitoresSemTurmaEspecifica = async () => {
        try {
            const ListarMonitoresSemTurmaEspecifica = await PessoaTurmaApi.listarMonitoresSemTurmaEspecificaAsync(turmaId);
            setMonitoresSemTurmaEspecifica(ListarMonitoresSemTurmaEspecifica);
        } catch (error) {
            console.error("Erro ao buscar monitores:", error.response.data);
        };
    }

    useEffect(() => {
        BuscarDadosDaTurma();
        ObterPessoasDaTurma();
        ListarPessoasSemTurmas();
        BuscarStatusTurma();
        BuscarPeriodosTurma();
        BuscarModalidadeTurma();
        ListarMonitoresSemTurmaEspecifica();
    }, [turmaId]);

    return (
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}
                <div className={style.pagina_conteudo}>
                    <div className={style.container_cabecalho}>
                        <h3>Editar Turma</h3>
                    </div>
                    <div className={style.conteudo_pagina}>
                        <div className={style.container_formulario}>
                            <h5>Dados</h5>
                            <Form className={style.formularo_dados}>
                                <Form.Group controlId="nome" className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <InputBuscar
                                        maxLength={100}
                                        type="text"
                                        placeholder="Nome"
                                        value={nomeNovo}
                                        onChange={(e) => setNomeNovo(e.target.value)}
                                    />
                                </Form.Group>

                                <Form.Group controlId="descricao" className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control
                                        maxLength={150}
                                        as="textarea"
                                        placeholder="descricao"
                                        value={descricaoNovo}
                                        onChange={(e) => setDescricaoNovo(e.target.value)}
                                    />
                                </Form.Group>

                                <Form.Group controlId="formPeriodo" className="mb-3">
                                    <Form.Label>Período</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="Periodo"
                                        value={periodoNovo}
                                        onChange={(e) => setPeriodoNovo(e.target.value)}
                                        required
                                    >
                                        <option value="">Selecione o período</option>
                                        {peridoTurmas.map((periodo) => (
                                            <option key={periodo.id} value={periodo.id}>
                                                {periodo.nome}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>

                                <Form.Group controlId="formModalidade" className="mb-3">
                                    <Form.Label>Modalidade</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="Modalidade"
                                        value={modalidadeNovo}
                                        onChange={(e) => setModalidadeNovo(e.target.value)}
                                        required
                                    >
                                        <option value="">Selecione a modalidade</option>
                                        {modalidadeTurmas.map((modalidade) => (
                                            <option key={modalidade.id} value={modalidade.id}>
                                                {modalidade.nome}
                                            </option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>

                                <Form.Group controlId="formStatusTurma" className="mb-3">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="statusTurma"
                                        value={statusNovo}
                                        onChange={(e) => setStatusNovo(e.target.value)}
                                        required
                                    >
                                        {statusTurmas
                                            .filter((statusTurma) => statusTurma.nome !== "Inativo")
                                            .map((statusTurma) => (
                                                <option key={statusTurma.id} value={statusTurma.id}>
                                                    {statusTurma.nome}
                                                </option>
                                            ))}
                                    </Form.Control>
                                </Form.Group>
                            </Form>
                            <div className={style.botao_dados}>
                                <Button onClick={BotaoEditarTurma} id={style.botao_salvar}>
                                    <MdSave /> Salvar
                                </Button>
                            </div>
                        </div>
                        <div className={style.lista_pessoas}>
                            <div className={style.cabecalho_pessoas}>
                                <h5>Alunos</h5>
                                <Button id={style.botao_adicionar} onClick={AbrirModalAdicionarAluno}>
                                    + Novo
                                </Button>
                            </div>
                            <div className={style.listas}>
                                <ul className={style.lista}>
                                    {pessoasDaTurma?.length > 0 ? (
                                        pessoasDaTurma
                                            .filter((pessoa) => pessoa.tipoPessoa === 3)
                                            .map((pessoa) => (
                                                <li className={style.lista_item} key={pessoa.id}>
                                                    <span title={pessoa?.nomeCompleto}>{pessoa?.nomeCompleto}</span>
                                                    <Link onClick={() => AbrirModalDeletar(pessoa)} className={style.botao_deletar}>
                                                        <IoMdClose />
                                                    </Link>
                                                </li>
                                            ))
                                    ) : (
                                        <li>
                                            Nenhum aluno encontrado
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className={style.lista_pessoas}>
                            <div className={style.cabecalho_pessoas}>
                                <h5>Monitores</h5>

                                <Button id={style.botao_adicionar} onClick={AbrirModalAdicionarMonitor}>
                                    + Novo
                                </Button>
                            </div>
                            <ul className={style.lista}>
                                {pessoasDaTurma?.length > 0 ? (
                                    pessoasDaTurma
                                        .filter((pessoa) => pessoa.tipoPessoa === 2)
                                        .map((pessoa) => (
                                            <li className={style.lista_item} key={pessoa.id}>
                                                <span title={pessoa?.nomeCompleto}>{pessoa?.nomeCompleto}</span>
                                                <Link onClick={() => AbrirModalDeletar(pessoa)} className={style.botao_deletar}>
                                                    <IoMdClose />
                                                </Link>
                                            </li>
                                        ))
                                ) : (
                                    <li>
                                        Nenhum monitor encontrado
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                    {/* Modal de confirmação para deletar aluno da turma */}
                    <Modal show={mostrarModalDeletar} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            Tem certeza que desassociar{" "}
                            {pessoaSelecionada?.nomeCompleto} da turma?
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="danger" onClick={BotaoRemoverPessoa}>
                                Deletar
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal para adicionar alunos na turma*/}
                    <Modal show={mostrarModalAdicionarAluno} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Adiconar alunos na turma</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <>
                                <Form.Group controlId="formUsuarios" className="mb-3">
                                    <Form.Label>Selecione os alunos</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={pessoasAdicionar[0] || ""}  // Mantém o valor selecionado
                                        onChange={(e) => {
                                            const selectedValue = Number(e.target.value); // Converte o valor para número
                                            if (selectedValue && !pessoasAdicionar.includes(selectedValue)) {
                                                setPessoasAdicionar([...pessoasAdicionar, selectedValue]); // Adiciona o aluno selecionado
                                            }
                                        }}
                                    >
                                        <option value="">Selecione um aluno</option>
                                        {pessoasSemTurma.filter(pessoa => pessoa.tipoPessoa === 3 && !pessoasAdicionar.includes(pessoa.id))  // Filtra os selecionados
                                            .map((pessoa) => (
                                                <option key={pessoa.id} value={pessoa.id}>
                                                    {pessoa.nomeCompleto}
                                                </option>
                                            ))}
                                    </Form.Control>
                                </Form.Group>

                                <div className={style.usuariosSelecionados}>
                                    {pessoasAdicionar.map((pessoaId) => {
                                        const pessoa = pessoasSemTurma.find(a => a.id === Number(pessoaId));

                                        return pessoa ? (
                                            <span key={pessoa.id} className={style.usuarioTag}>
                                                <p>{pessoa.nomeCompleto}</p>
                                                <button
                                                    className={style.removerUsuario}
                                                    onClick={() => setPessoasAdicionar(pessoasAdicionar.filter(id => id !== pessoa.id))}
                                                >
                                                    <TiDelete size={20} />
                                                </button>
                                            </span>
                                        ) : null;
                                    })}
                                </div>
                            </>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary " onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={BotaoAdicionarPessoa}>
                                Salvar
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Modal para adicionar alunos na turma*/}
                    <Modal show={mostrarModalAdicionarMonitor} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Adiconar monitores na turma</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <>
                                <Form.Group controlId="formUsuarios" className="mb-3">
                                    <Form.Label>Selecione os monitores</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={pessoasAdicionar[0] || ""}  // Mantém o valor selecionado
                                        onChange={(e) => {
                                            const selectedValue = Number(e.target.value); // Converte o valor para número
                                            if (selectedValue && !pessoasAdicionar.includes(selectedValue)) {
                                                setPessoasAdicionar([...pessoasAdicionar, selectedValue]); // Adiciona o aluno selecionado
                                            }
                                        }}
                                    >
                                        <option value="">Selecione um monitor</option>
                                        {monitoresSemTurmaEspecifica.filter(pessoa => !pessoasAdicionar.includes(pessoa.id))  // Filtra os selecionados
                                            .map((pessoa) => (
                                                <option key={pessoa.id} value={pessoa.id}>
                                                    {pessoa.nomeCompleto}
                                                </option>
                                            ))}
                                    </Form.Control>
                                </Form.Group>

                                <div className={style.usuariosSelecionados}>
                                    {pessoasAdicionar.map((pessoaId) => {
                                        const pessoa = monitoresSemTurmaEspecifica.find(a => a.id === Number(pessoaId));

                                        return pessoa ? (
                                            <span key={pessoa.id} className={style.usuarioTag}>
                                                <p>{pessoa.nomeCompleto}</p>
                                                <button
                                                    className={style.removerUsuario}
                                                    onClick={() => setPessoasAdicionar(pessoasAdicionar.filter(id => id !== pessoa.id))}
                                                >
                                                    <TiDelete size={20} />
                                                </button>
                                            </span>
                                        ) : null;
                                    })}
                                </div>
                            </>
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary " onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={BotaoAdicionarPessoa}>
                                Salvar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </Topbar >
        </Sidebar>
    );
}


export default EditarTurma;